<!-- eslint-disable max-len -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    width="25"
    height="25"
    viewBox="0 0 24 24"
    xml:space="preserve"
  >
    <path
      :fill="pathFill"
      d="M13.521,14.585V5.476c0-0.513-0.417-0.93-0.929-0.93H6.122c-0.513,0-0.93,0.417-0.93,0.93v9.109  c0,0.513,0.417,0.93,0.93,0.93h6.471C13.104,15.515,13.521,15.098,13.521,14.585z M12.521,14.516l-6.329,0.069l-0.07-9.039h6.399  V14.516z"
    />
    <path
      :fill="pathFill"
      d="M10.797,16.087H7.918c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h2.879c0.276,0,0.5-0.224,0.5-0.5  S11.073,16.087,10.797,16.087z"
    />
    <path
      :fill="pathFill"
      d="M19.25,7.5h-0.011V7.104c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5V7.5h-0.01c-0.558,0-1.011,0.453-1.011,1.01v2.979  c0,0.557,0.453,1.01,1.011,1.01h0.01v5.688c0,0.999-0.813,1.813-1.813,1.813H11.67c-0.892,0-1.632-0.65-1.781-1.5h2.961  c1.172,0,2.125-0.953,2.125-2.125V5.125C14.975,3.953,14.021,3,12.85,3H5.864C4.692,3,3.739,3.953,3.739,5.125v11.25  c0,1.172,0.953,2.125,2.125,2.125h3.025c0.158,1.402,1.337,2.5,2.781,2.5h4.757c1.551,0,2.813-1.262,2.813-2.813V12.5h0.011  c0.558,0,1.011-0.453,1.011-1.01V8.51C20.261,7.953,19.808,7.5,19.25,7.5z M4.739,16.375V5.125C4.739,4.505,5.244,4,5.864,4h6.985  c0.62,0,1.125,0.505,1.125,1.125v11.25c0,0.62-0.505,1.125-1.125,1.125H5.864C5.244,17.5,4.739,16.995,4.739,16.375z M19.261,11.49  c0,0.006-0.005,0.01-0.011,0.01l-1.031-0.01l0.011-2.99l1.031,0.01V11.49z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
